import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Post from "./Post.jsx";
import { t } from "../i18n";
import "./PostPage.css";
import { api } from "../utils/api";
import { getSessionAuth } from "../utils/auth";

const PostPage = () => {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const { userId } = getSessionAuth();

  const checkBlockedStatus = useCallback(async () => {
    try {
      const result = await api.get(`/users/${userId}`);
      const blockedPosts = result.attributes?.blockedPosts || [];
      setIsBlocked(blockedPosts.includes(Number(postId)));
    } catch (error) {
      console.error("Error checking blocked status:", error);
    }
  }, [postId, userId]);

  const loadPost = useCallback(async () => {
    try {
      const result = await api.get(`/posts/${postId}`);
      setPost(result);
      setIsLoaded(true);
    } catch (err) {
      console.error("Error loading post:", err);
      setIsLoaded(true);
    }
  }, [postId]);

  useEffect(() => {
    loadPost();
    checkBlockedStatus();
  }, [checkBlockedStatus, loadPost]);

  if (!isLoaded) {
    return <div>{t("loading")}</div>;
  }

  if (!post) {
    return <div>{t("post_not_found")}</div>;
  }

  if (isBlocked) {
    return <div>{t("post_blocked")}</div>;
  }

  return (
    <div className="post-page">
      <Post
        post={post}
        type="postlist"
        loadPosts={loadPost}
        defaultShowModal={true}
      />
    </div>
  );
};

export default PostPage;
